export class ForkliftFilterDto {

    public accessControlId: number | undefined | null = null;
    public addressId: number | null = null;
    public gateId: number | null = null;

    public static build(accessControlId: number | undefined, addressId: number, gateId: number): ForkliftFilterDto {
        const dto = new ForkliftFilterDto();
        dto.accessControlId = accessControlId;
        dto.addressId = addressId;
        dto.gateId = gateId;
        return dto;
    }

    public static equals(a: ForkliftFilterDto, b: ForkliftFilterDto): boolean {
        if (a === b)
            return true;
        if (!a || !b)
            return false;
        return a.accessControlId === b.accessControlId
            && a.addressId === b.addressId
            && a.gateId === b.gateId;
    }

}
